/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q3_AInputs */

const en_consult_q3_a = /** @type {(inputs: Consult_Q3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready within 30 days`)
};

const id_consult_q3_a = /** @type {(inputs: Consult_Q3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap mulai dalam 30 hari`)
};

/**
* | output |
* | --- |
* | "Ready within 30 days" |
*
* @param {Consult_Q3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q3_a = /** @type {((inputs?: Consult_Q3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q3_a(inputs)
	return en_consult_q3_a(inputs)
});